/*
 *  -----------------------------------------------------------------------
 *    <copyright file="import-study/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogContent } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'hooks';
import { StudyConfigurationImportType } from 'types/graphql-global-types';
import Button from 'views/components/core/buttons';
import { CustomDialog, DialogActions, DialogTitle } from 'views/components/core/dialog';
import ItemList from 'views/components/core/item-list';
import './styles.scss';

const configList = [
    {
        name: 'Study',
        id: StudyConfigurationImportType.STUDIES,
    },
    {
        name: 'Dashboard Panels',
        id: StudyConfigurationImportType.PANELS,
    },
    {
        name: 'Data Tables',
        id: StudyConfigurationImportType.DATA_TABLES,
    },
    {
        name: 'Study & Site Dashboard Setup',
        id: StudyConfigurationImportType.DASHBOARDS,
    },
    {
        name: 'Subject Visit Schedules (visits, CRFs and assessments)',
        id: StudyConfigurationImportType.SV_TS,
    },
    {
        name: 'Extra Data Fields',
        id: StudyConfigurationImportType.EXTRA_DATA_FIELDS,
    },
];

const ImportStudy = ({ open, onClose, isImporting }: { open: boolean; onClose: Function; isImporting: boolean }) => {
    const { t } = useTranslation();
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        if (!open) setSelectedItems([]);
    }, [open]);

    const importSelectedItems = () => {
        onClose(selectedItems);
    };

    return (
        <CustomDialog
            onClose={() => {
                onClose();
            }}
            maxWidth="md"
            fullWidth
            scroll="paper"
            open={open}
        >
            <DialogTitle id="import-study-config-modal-title">
                {t('admin:importStudy')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={() => {
                        onClose();
                    }}
                    data-testid="close-dialog"
                />
            </DialogTitle>
            <DialogContent className="import-study-dialog-content">
                <div className="import-file-text">{t('admin:selectConfigAreasToImport')}</div>
                <div className="add-config-list">
                    <ItemList
                        id="add-config-item"
                        items={configList}
                        textField="name"
                        multiselect
                        selectedItems={selectedItems}
                        onSelectionChange={setSelectedItems}
                    />
                </div>
                <DialogActions className="import-study-actions flex-end">
                    <Button
                        id="import-config-study-btn"
                        text={isImporting ? t('common:importingStudy') : t('common:Import')}
                        onClick={importSelectedItems}
                        disabled={!selectedItems.length || isImporting}
                    />
                </DialogActions>
            </DialogContent>
        </CustomDialog>
    );
};

export default ImportStudy;
